import React from "react";
import useHandleBoxTypes from "../../hooks/useHandleBoxTypes";
import useHover from "../../hooks/useHover";
import MainStore from "../../stores/MainStore";

const ObjectListHolder = ({
  object,
  width,
  imageSize = 25,
  onObjectClicked,
}) => {
  const hover = useHover();
  const { player } = MainStore();
  const { getBoxType } = useHandleBoxTypes();
  const boxType = getBoxType(object?.type);
  return (
    <div
      onClick={() => {
        if (onObjectClicked) onObjectClicked(object);
      }}
      {...hover.divProps}
      className="divRow"
      style={{
        cursor: "pointer",
        width,
        border: "3px solid grey",
        padding: "2px",
        borderRadius: ".4rem/.4rem",
        backgroundColor: hover.hover ? "#5f5f5f" : "#afafaf",
      }}
    >
      <img
        src={object?.image}
        style={{
          objectFit: "contain",
          height: `${imageSize}px`,
          marginLeft: "5px",
        }}
      />
      <div
        className="textBold"
        style={{
          flex: 1,
          textAlign: "center",
          color: hover.hover ? "gold" : boxType.colors.text,
        }}
      >
        {object?.shortDescription}
      </div>
      <MoreInfoButton id={object?.id} />
      <img
        src={`/icons/icon_${object?.type}.png`}
        style={{ objectFit: "contain", height: `${imageSize}px` }}
      />
    </div>
  );
};

const MoreInfoButton = ({ id }) => {
  const hover = useHover();
  return (
    <div
      {...hover.divProps}
      className="divRow"
      style={{
        backgroundColor: hover.hover ? "white" : null,
        border: "1px solid grey",
        borderRadius: "1rem/1rem",
        height: "15px",
        padding: "5px",
      }}
    >
      <div
        className="textBoldWhite"
        style={{ color: hover.hover ? "black" : "#363636" }}
      >
        More Info
      </div>
    </div>
  );
};

export default ObjectListHolder;
